// One formatter for every practice-facing date (AVDEMO item 2, 2026-09-28):
// a date-only value (`YYYY-MM-DD`, no time component) renders as that exact
// calendar date -- parsing it with an explicit local midnight avoids the
// classic UTC-parse day-shift. A timestamp renders in the VIEWER's own zone
// (the browser default), never pinned to UTC -- a person reading a
// re-check date cares what day it was for them, not for the server.
export function formatCalendarDate(dateOnly: string): string {
  return new Date(`${dateOnly}T00:00:00`).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatViewerDate(
  timestamp: string,
  opts: Intl.DateTimeFormatOptions = { dateStyle: 'medium' },
): string {
  return new Intl.DateTimeFormat(undefined, opts).format(new Date(timestamp));
}

/** `YYYY-MM` (a reporting period) in the viewer's style: "Jan 2026". */
export function formatCalendarMonth(yearMonth: string): string {
  const [year, month] = yearMonth.split('-').map(Number);
  if (!year || !month) return yearMonth;
  return new Date(year, month - 1, 1).toLocaleDateString(undefined, { year: 'numeric', month: 'short' });
}

/** A date inside a sentence or an email: "September 28, 2026" (lists and cards
 *  use `formatCalendarDate`'s "Sep 28, 2026"). */
export function formatSentenceDate(dateOnly: string): string {
  return new Date(`${dateOnly}T00:00:00`).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

/** A plain ISO day ("2026-09-28") as the list form ("Sep 28, 2026"); any other
 *  text (a "not recorded" placeholder) is returned as it is. */
export function listDateText(text: string): string {
  return /^\d{4}-\d{2}-\d{2}$/.test(text) ? formatCalendarDate(text) : text;
}
